import React from "react";
import { useForm } from "react-hook-form";
import validator from "validator";
import formBackgrounImg from "../Img/service-img-bg.jpg";

const services = [
  "Puzzle Parking",
  "Puzzle Pit Parking",
  "4 Level Pit Parking",
  "3 Level Parking",
  "3 Level Pit Parking",
  "2 Level Parking",
  "2 Level Pit Parking",
  "Tower Parking",
  "Rotary Parking",
];

const ServiceRequestForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = (data) => {
    console.log("Validated Data:", data);
    // Optional: send to API
    reset();
  };

  return (
    <div
      className="lt-service-form-wrapper"
      style={{ backgroundImage: `url(${formBackgrounImg})` }}
    >
      <form className="lt-service-form" onSubmit={handleSubmit(onSubmit)}>
        <h3>Request a Parking Solution</h3>

        <div className="lt-form-grid">
          <div className="lt-form-group">
            <input
              type="text"
              placeholder="Your Name"
              {...register("name", { required: "Name is required" })}
            />
            {errors.name && <p className="lt-error">{errors.name.message}</p>}
          </div>

          <div className="lt-form-group">
            <input
              type="email"
              placeholder="Your Email"
              {...register("email", {
                required: "Email is required",
                validate: (value) =>
                  validator.isEmail(value) || "Invalid email address",
              })}
            />
            {errors.email && <p className="lt-error">{errors.email.message}</p>}
          </div>

          <div className="lt-form-group">
            <input
              type="tel"
              placeholder="Mobile Number"
              {...register("number", {
                required: "Mobile number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Must be 10 digits",
                },
              })}
            />
            {errors.number && <p className="lt-error">{errors.number.message}</p>}
          </div>

          <div className="lt-form-group">
            <input
              type="text"
              placeholder="Pincode"
              {...register("pincode", {
                required: "Pincode is required",
                pattern: {
                  value: /^[0-9]{6}$/,
                  message: "Must be 6 digits",
                },
              })}
            />
            {errors.pincode && <p className="lt-error">{errors.pincode.message}</p>}
          </div>

          <div className="lt-form-group lt-full-width">
            <select {...register("service", { required: "Please select a service" })}>
              <option value="">Select Service</option>
              {services.map((s, idx) => (
                <option key={idx} value={s}>
                  {s}
                </option>
              ))}
            </select>
            {errors.service && <p className="lt-error">{errors.service.message}</p>}
          </div>
        </div>

        <button type="submit">Submit Request</button>
      </form>
    </div>
  );
};

export default ServiceRequestForm;
